import React from 'react';
import '../styles/books_in_adding.scss';

export const BooksInAddind = ({ numberOfCopies, handleChange }) => {
  const changeQuantity = num => {
    const e = {
      target: {
        name: 'numberOfCopies',
        value: numberOfCopies + num || 1,
      },
    };
    handleChange(e);
  };

  return (
    <div className="books-in-adding-wrapper">
      <div className="books-in-adding-background" />
      <div className="books-in-adding">
        <div role="none" className="item negative" onClick={() => changeQuantity(-1)} />
        <div className="item result">{numberOfCopies}</div>
        <div role="none" className="item positive" onClick={() => changeQuantity(1)} />
      </div>
    </div>
  );
};
